var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/phone_number/index.js
 ** module id = 258
 ** module chunks = 0
 **/